import React, {useContext, useEffect} from "react";
import Links from "../../../Route";
import {Redirect} from "react-router-dom";
import AuthenticationContext from "../../../services/AuthenticationContext";
import AuthenticationAPI from "../../../services/AuthenticationAPI";

const Logout = ({history}) => {

    const {isAuthenticated, setIsAuthenticated} = useContext(AuthenticationContext);

    const handleLogout = () => {
        AuthenticationAPI.logout();
        setIsAuthenticated(false);
    }

    useEffect(() => {
        if(isAuthenticated){
            handleLogout();
        }
    }, [handleLogout, isAuthenticated]);

    let route = Links.Home.link;
    if(AuthenticationAPI.getCurrentAuth()){
        route = Links.SignIn.link;
    }
    return (
         <Redirect to={route} />
    );
}

export default Logout;